import { useQuery } from "@apollo/client";
import { PimsRessourcesDocument } from "../../../../../../__generated__/graphql";

export default function usePimsRessources({
  shouldFetch,
}: {
  shouldFetch: boolean;
}) {
  const { data, loading, error } = useQuery(PimsRessourcesDocument, {
    skip: !shouldFetch,
  });

  return { data, loading, error };
}
